import { render, staticRenderFns } from "./PageRowSeparator.vue?vue&type=template&id=46c6da7d&scoped=true&"
import script from "./PageRowSeparator.vue?vue&type=script&lang=js&"
export * from "./PageRowSeparator.vue?vue&type=script&lang=js&"
import style0 from "./PageRowSeparator.vue?vue&type=style&index=0&id=46c6da7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c6da7d",
  null
  
)

export default component.exports